import Marquee from "react-fast-marquee";

const items = [
  "Free UPS Shipping",
  "30-Day Returns",
  "PhoneCheck Certified 100% Functional",
  "1-Year Replacement Warranty",
  "100% Guaranteed",
  "Lease-to-Own with Payvantage",
];

export default function TrustMarquee({ dark = false }) {
  const loop = [...items, ...items, ...items];
  return (
    <div className={`border-y ${dark ? "border-white/10 bg-surface-dark" : "border-line bg-alt"}`} data-testid="trust-marquee">
      <Marquee speed={40} gradient={false} className="py-5">
        {loop.map((t, i) => (
          <span key={i} className="flex items-center text-sm font-bold uppercase tracking-widest">
            <span className={dark ? "text-white/80" : "text-ink"}>{t}</span>
            <span className="mx-8 text-crimson">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
